import { useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
// import { bannerAddEdit } from "../../../../services/bannersService";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Textarea from "../../../form/Textarea";
import { toast } from "react-toastify";
import Select from "../../../form/select/Select";
import { useMutation } from "@tanstack/react-query";
import { useDebounce } from "../../../../hooks/useDebounce";
import { useSelector } from "react-redux";
import { organizationAddEdit } from "../../../../services/organizationService";

const validation = {
  name: { required: true, message: "Name is required" },
  contactEmail: [
    {
      required: true,
      message: "Enter Valid Email",
    },
  ],
};

const ManageOrganization = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: validation,
  });

  //   const { data: pages } = useQuery({
  //     queryKey: ["page", pageFilters, pageSearch],
  //     queryFn: async () => {
  //       const res = await pageList({
  //         ...pageFilters,
  //         parentId: null,
  //         ...(pageSearch && { keyword: pageSearch }),
  //       });
  //       if (res?.docs?.status === 200) {
  //         return {
  //           ...res?.docs,
  //           data: removeDuplicateFromArray([
  //             ...(pages?.data || []),
  //             ...res?.docs?.data,
  //           ]),
  //         };
  //       } else {
  //         if (pages?.data?.length > 0) {
  //           return pages;
  //         } else {
  //           return res;
  //         }
  //       }
  //     },
  //   });

  //   function loadData(e, obj, setData = () => {}) {
  //     if (
  //       Math.ceil(e.target.scrollTop) + 20 >=
  //         e.target.scrollHeight - e.target.clientHeight &&
  //       obj?.metadata?.hasNextPage
  //     ) {
  //       setData((pre) => ({
  //         ...pre,
  //         page: obj?.metadata?.nextPage,
  //       }));
  //     }
  //   }

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        logo: data?.logo?.url,
        coverImage: data?.coverImage?.url,
      });
    }
  }, [data]);

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        ...(data?._id && { id: data?._id }),
      };

      return await organizationAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        getResponse(res);
        return res;
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="h-full p-4">
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          <div className="relative col-span-6">
            <Input
              label="Organization Name"
              inputPlaceholder={"Enter Organization Name"}
              inputName="name"
              value={values?.name || ""}
              onChange={handleChange}
              {...formValidate(errors, "name")}
            />
          </div>
          <div className="relative col-span-6">
            <Select
              label={"Organization Type"}
              placeholder="Enter Organization Type"
              selectedValue={values?.type}
              dropdownData={[
                { name: "Platform", value: "platform" },
                { name: "Organizer", value: "organizer" },
                { name: "Agency", value: "agency" },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "type", value: val } });
              }}
              {...formValidate(errors, "type")}
            />
          </div>

          <div className="relative col-span-12">
            <FileUploadSingle
              label={"Upload Cover Image"}
              labelClasses={"!mb-2"}
              value={values?.coverImage}
              onChange={(file) =>
                handleChange({ target: { name: "coverImage", value: file } })
              }
              {...formValidate(errors, "coverImage")}
            />
          </div>

          <div className="relative col-span-12">
            <FileUploadSingle
              label={"Upload Logo Image"}
              labelClasses={"!mb-2"}
              value={values?.logo}
              onChange={(file) =>
                handleChange({ target: { name: "logo", value: file } })
              }
              {...formValidate(errors, "logo")}
            />
          </div>

          <div className="relative col-span-12">
            <Textarea
              label="Description"
              inputPlaceholder={"Enter Description"}
              inputName="description"
              inputValue={values?.description || ""}
              onChange={handleChange}
              {...formValidate(errors, "description")}
            />
          </div>

          <div className="relative col-span-6">
            <Input
              label="Contact Email"
              inputPlaceholder={"Enter Contact Email"}
              inputName="contactEmail"
              value={values?.contactEmail || ""}
              onChange={handleChange}
              {...formValidate(errors, "contactEmail")}
            />
          </div>

          <div className="relative col-span-6">
            <Input
              label="Website"
              inputPlaceholder={"Enter Website"}
              inputName="website"
              value={values?.website || ""}
              onChange={handleChange}
              {...formValidate(errors, "website")}
            />
          </div>

          <div className="relative col-span-6">
            <Select
              label={"Verified"}
              placeholder="Select Verified"
              selectedValue={values?.verified}
              dropdownData={[
                { name: "Yes", value: true },
                { name: "No", value: false },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "verified", value: val } });
              }}
              {...formValidate(errors, "verified")}
            />
          </div>

          <div className="relative col-span-6">
            <Select
              label={"Suspended"}
              placeholder="Select Suspended"
              selectedValue={values?.isSuspended}
              dropdownData={[
                { name: "Yes", value: true },
                { name: "No", value: false },
              ]}
              onChange={(val) => {
                handleChange({ target: { name: "isSuspended", value: val } });
              }}
              {...formValidate(errors, "isSuspended")}
            />
          </div>
        </div>
        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType="submit"
              buttonLabel={"Save Organization"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
            <Button
              buttonLabel={"Cancel"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-primary !bg-transparent !text-primary hover:!bg-primary hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonFunction={close}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManageOrganization;
